import { gql } from '@apollo/client';

export const studentFragment = gql`
  fragment StudentFragment on Student {
    id
    email
    username
    firstName
    lastName
    emeji
    decryptedPassword
    canUpdatePassword
    currentClasses {
      id
      className
      classTeacherDisplayName
      classToDoId
      createdAt
      teacherEmeji
      colour
      teacherId
      featureFlags
    }
  }
`;

export const GET_CLASS_STUDENTS = gql`
  query GetClassStudents($input: GetClassStudentsInput!) {
    getClassStudents(input: $input) {
      ... on Student {
        ...StudentFragment
      }
    }
  }
  ${studentFragment}
`;

export const ADD_STUDENTS_TO_CLASS = gql`
  mutation AddStudentsToClass($input: AddStudentsToClassInput!) {
    addStudentsToClass(input: $input) {
      students {
        ...StudentFragment
      }
      invalidEmails {
        email
        reason
        student {
          id
        }
      }
    }
  }
  ${studentFragment}
`;

export const ADD_STUDENTS_BY_NAME_TO_CLASS = gql`
  mutation AddStudentsByNameToClass($input: AddStudentsByNameToClassInput!) {
    addStudentsByNameToClass(input: $input) {
      ... on Student {
        ...StudentFragment
      }
    }
  }
  ${studentFragment}
`;

export const BULK_ADD_STUDENTS_TO_CLASS = gql`
  mutation BulkAddStudentsToClass($input: BulkAddStudentsToClassInput!) {
    bulkAddStudentsToClass(input: $input) {
      students {
        ...StudentFragment
      }
      invalidEntries {
        ... on InvalidEmail {
          email
          emailReason: reason
          student {
            ...StudentFragment
          }
        }
        ... on InvalidStudentName {
          name
          nameReason: reason
          students {
            ...StudentFragment
          }
        }
      }
    }
  }
  ${studentFragment}
`;

export const IMPORT_STUDENTS_FROM_GOOGLE_CLASSROOM = gql`
  mutation ImportStudentsFromGoogleClassroom(
    $input: ImportStudentsFromGoogleClassroomInput!
  ) {
    importStudentsFromGoogleClassroom(input: $input) {
      students {
        ...StudentFragment
      }
      exceededEmails
    }
  }
  ${studentFragment}
`;

export const UNLINK_GOOGLE_CLASSROOM = gql`
  mutation UnlinkGoogleClassroom {
    unlinkGoogleClassroom {
      ... on User {
        id
        connectedGoogleClassroomEmail
        hasGoogleClassroomPermissions
      }
    }
  }
`;

export const REMOVE_STUDENTS_FROM_CLASS = gql`
  mutation RemoveStudentsFromClass($input: RemoveStudentsFromClassInput!) {
    removeStudentsFromClass(input: $input) {
      ... on Student {
        ...StudentFragment
      }
    }
  }
  ${studentFragment}
`;

export const COPY_STUDENTS_TO_CLASS = gql`
  mutation CopyStudentsToClass($input: CopyStudentsToClassInput!) {
    copyStudentsToClass(input: $input)
  }
`;

export const GET_STUDENT = gql`
  query GetStudent {
    getStudent {
      ...StudentFragment
    }
  }
  ${studentFragment}
`;

export const GET_GOOGLE_CLASSROOM_AUTH_URL = gql`
  query GetGoogleClassroomAuthUrl {
    getGoogleClassroomAuthUrl
  }
`;

export const GET_GOOGLE_CLASSROOM_LIST = gql`
  query GetGoogleClassroomList {
    getGoogleClassroomList {
      id
      name
    }
  }
`;

export const UPDATE_STUDENT_INFORMATION = gql`
  mutation UpdateStudentInformation($input: UpdateStudentInformationInput!) {
    updateStudentInformation(input: $input) {
      ...StudentFragment
    }
  }
  ${studentFragment}
`;

export const CHECK_DUPLICATE_STUDENT = gql`
  query CheckDuplicateStudent($input: CheckDuplicateStudentInput!) {
    checkDuplicateStudent(input: $input) {
      firstName
      lastName
      username
      email
      classes {
        teacher
        className
        years
      }
    }
  }
`;
